<template>
  <v-tooltip
 
    left
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        icon
        v-bind="attrs"
        v-on="on"
      >
        <v-icon
          style="color: #1976d2"
          v-bind="attrs"
          size="20"
          v-on="on"
        >
          mdi-alert-circle-outline
        </v-icon>
      </v-btn>
    </template>
    <div>
      <div>什么情况下需要申请虚拟子合同：</div>
      <div style="text-indent:2em;max-width:300px">
        主合同以集团内某一公司主体名义代表集团整体签署，并在合同内约定由集团内其他公司分别承担费用并支付相应款项。若申请付款主体与主合同签订主体不一致，则需要申请虚拟子合同。
      </div>
    </div>
  </v-tooltip>
</template>
<script>
  export default {
    
  }
</script>